import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('BookingItemStore')
@observer
class BookingSubCategorySearchModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Sub Category',
                dataIndex: 'name',
                key: 'name',
                width: '80%'
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: id => (
                    <span>
                        <Button onClick={() => this.selectSubCategoryOnClick(id)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    // ON CHANGE

    subcategoryOnChange = e => {
        this.props.BookingItemStore.setSubCategorySearchValue(e.target.value);
        this.props.BookingItemStore.searchSubCategory();
    }

    // ON CLICK

    selectSubCategoryOnClick = subcategoryId => {
        this.props.BookingItemStore.searchSubCategorySelected(subcategoryId);
        this.props.BookingItemStore.setShowBookingSubCategorySearchModal(false);
    }

    render() {
        const {
            bookingSubCategoryFilter,
            subCategorySearchValue
        } = this.props.BookingItemStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Sub Category' value={subCategorySearchValue} onChange={this.subcategoryOnChange} />
                <Table columns={this.getColumns()} dataSource={bookingSubCategoryFilter} />
            </React.Fragment>
        )
    }
}

export default BookingSubCategorySearchModalPage;
